import { m } from 'framer-motion';
// @mui
import { Theme, SxProps } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
// components
import Iconify from 'src/components/iconify';
import { varHover } from 'src/components/animate';
import { useBoolean } from 'src/hooks/use-boolean';
import HistoryTableDataChange from 'src/sections/table/action/history-table-data-change';
import { Tooltip } from '@mui/material';

// ----------------------------------------------------------------------

type Props = {
  sx?: SxProps<Theme>;
};

export default function HistoryButton({ sx }: Props) {
  const openHistory = useBoolean();

  return (
    <>
      <Tooltip title="Nhật ký thay đổi dữ liệu">
        <IconButton
          component={m.button}
          whileTap="tap"
          whileHover="hover"
          variants={varHover(1.05)}
          onClick={openHistory.onTrue}
          sx={{
            width: 40,
            height: 40,
            ...(openHistory.value && {
              bgcolor: 'action.selected',
            }),
            color: 'primary.main',
          }}
        >
          <Iconify icon="mdi:clock-edit" width={24} />
        </IconButton>
      </Tooltip>

      <HistoryTableDataChange open={openHistory.value} onClose={() => openHistory.onFalse()} />
    </>
  );
}
